export default [
    {
        name:"管线",
        /**
         * 标志结点类型,主要有四种，0，1，2，10
         * 0 代表连接多个管道
         * 1 代表只能连接一个管道
         * 2 代表只能在管道上移动
         * 10代表是管道
         */

        _node_type:10, 
        _type:"line", // 标志图形的类型,为唯一值
        img:"line.png",
    },
    {
        name:"分支",
        _type:"branch", 
        _node_type:0, 
        img:"branch.png",
    },

    {
        name:"输入节点",
        _node_type:1,
        _type:"input",
        img:"in.png",
    },
    {
        name:"待求输入节点",
        _node_type:1,
        _type:"unknownInput",
        img:"in_q.png",
    },
    {
        name:"输出节点",
        _node_type:1,
        _type:"output",
        img:"out.png",
    },
    {
        name:"待求输出节点",
        _node_type:1,
        _type:"unknowOutput",
        img:"out_q.png",
    },

    {
        name:"储罐",
        _node_type:1,
        _type:"storage_tank",
        img:"storage_tank.png",
    },
    {
        name:"变径",
        _type:"reduce_diameter",
        _node_type:1,
        img:"area.png",
    },
    {
        name:"弯头",
        _type:"bend",
        _node_type:1,
        img:"bend.png",
    },
    {
        name:"三通",
        _type:"tee",
        _node_type:1,
        img:"tee.png",
    },
    {
        /**
         * 只能在线上移动，如果管道上有阀门，那么管道属性无法编辑
         */
        name:"阀门",
        _type:"valve",
        _node_type:2, 
        img:"valve.png",
    },
    {
        name:"控制阀",
        _type:"control_valve",
        _node_type:2,
        img:"control.png",
    },
    {
        name:"止回阀",
        _type:"check_valve",
        _node_type:1,
        img:"check.png",
    },
    {
        name:"安全阀",
        _type:"safety_valva",
        _node_type:1,
        img:"relief.png",
    },
    {
        name:"盲端",
        _type:"blind_end",
        _node_type:1,
        img:"dead.png",
    },
    {
        name:"孔板",
        _type:"orifice_plate",
        _node_type:1,
        img:"orifice.png",
    },
    {
        name:"文丘里管",
        _type:"venturi_tube",
        _node_type:1,
        img:"venturi.png",
    },
    {
        name:"过滤筛",
        _type:"filter_screen",
        _node_type:1,
        img:"screen.png",
    },
    {
        name:"换热器",
        _type:"heat_exchanger",
        _node_type:1,
        img:"heat.png",
    },
    {
        name:"喷淋头",
        _type:"sprinkler_head",
        _node_type:1,
        img:"spray.png",
    },
    {
        name:"压缩机",
        _type:"compressor",
        _node_type:1,
        img:"compressor.png",
    },
    {
        name:"分离器",
        _type:"separator",
        _node_type:1,
        img:"separator.png",
    },
    {
        name:"通用元件",
        _type:"general_components",
        _node_type:1,
        img:"general.png",
    },
    {
        name:"水泵",
        _type:"pump",
        _node_type:2,
        img:"pump.png",
    },
    {
        name:"水池",
        _type:"tank",
        _node_type:0,
        img:"tank.png",
    },
    {
        name:"水库",
        _type:"reservoir",
        _node_type:0,
        img:"reservoir.png",
    }
];